let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("l6xiM"), load("56LBA"), load("58BxS")]).then(() => parcelRequire('6u5sT'));